<div
        class="customizer-backdrop"
        *ngIf="isCustomizerOpen"
        (click)="toggleCustomizer()"
></div>

<div

        class="customizer fade"
        [class.show]="isCustomizerOpen"
        [class.d-block]="isCustomizerOpen"
        [ngStyle]="{ width: customizerWidth }"
>
    <!-- Settings Panel -->
    <div class="customizer-content" [class.active]="isSettingsPanelOpen">
        <div class="settings-header">
            <div class="d-flex justify-content-start align-items-start">
                <div class="d-flex align-items-center">
                    <ng-container>
                        <img [src]="file" class="logo-img me-2" alt="Logo">
                        <label class="d-flex align-items-center">
                            <strong class="size20 me-1">{{ documentType }}</strong>
                            <span class="text-muted size20"> / {{ documentId }}</span>
                        </label>
                    </ng-container>
                </div>
            </div>
            <a class="customizer-close" (click)="toggleCustomizer()">
                <span [data-feather]="'x'"></span>
            </a>
        </div>

        <!-- Tab Content -->
        <div class="items mt-4 d-flex">
            <div class="flex-grow-1" style="padding: 0 0 0 36px;">
                <p style="font-size: 15px;color:#2F2B3DE5" *ngIf="documentType==='DEVIS' || documentType==='COMMANDE CLIENT' || documentType==='BON DE LIVRAISON' || documentType==='BON DE SORTIE' || documentType==='FACTURE'">
                    <strong>Client</strong>
                </p>
                <p style="font-size: 15px;color:#2F2B3DE5" *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">
                    <strong>Fournisseur</strong>
                </p>
                <hr class="section-line">

                <!-- Client Info -->
                <div class="d-flex gap-120px" *ngIf="documentType==='DEVIS' || documentType==='COMMANDE CLIENT' || documentType==='BON DE LIVRAISON' || documentType==='BON DE SORTIE' || documentType==='FACTURE'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Nom du client</label></td>
                            <td><label class="size15-400">{{ partyName }}</label></td>                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType==='DEVIS' || documentType==='COMMANDE CLIENT' || documentType==='BON DE LIVRAISON' || documentType==='BON DE SORTIE' || documentType==='FACTURE'">

                <!-- Fournisseur Info -->
                <div class="d-flex gap-120px" *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Entreprise</label></td>
                            <td><label class="size15-400">DISTRIBUTION MELKI</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">

                <!-- Identifiant unique -->
                <div class="d-flex gap-100px" *ngIf="documentType==='DEVIS' || documentType==='COMMANDE CLIENT' || documentType==='BON DE LIVRAISON' || documentType==='BON DE SORTIE' || documentType==='FACTURE'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Identifiant unique</label></td>
                            <td><label class="size15-400">{{ documentId }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType==='DEVIS' || documentType==='COMMANDE CLIENT' || documentType==='BON DE LIVRAISON' || documentType==='BON DE SORTIE' || documentType==='FACTURE'">

                <!-- Numéro d'identification fiscale -->
                <div class="d-flex gap-120px" *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Numéro d'identification fiscale</label></td>
                            <td><label class="size15-400">212</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">

                <!-- Responsable -->
                <div class="d-flex gap-120px" *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Responsable</label></td>
                            <td><label class="size15-400">Fathi</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">

                <!-- Numéro de portable -->
                <div class="d-flex gap-120px" *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Numéro de portable</label></td>
                            <td><label class="size15-400">{{ partyPhone }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">

                <!-- Adresse -->
                <div class="d-flex gap-120px">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Adresse</label></td>
                            <td><label class="size15-400">{{ partyAddress }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr>

                <!-- Email -->
                <div class="d-flex gap-120px">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Email</label></td>
                            <td><label class="size15-400">{{ partyEmail }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr>
            </div>

            <!-- Partie Détails du document -->
            <div class="flex-grow-1" style="padding: 0;">
                <p style="font-size: 15px;color:#2F2B3DE5"><strong>Détails du document</strong></p>
                <hr class="section-line">

                <!-- Référence externe -->
                <div class="d-flex gap-120px" *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Référence externe</label></td>
                            <td><label class="size15-400">{{ documentId }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType==='COMMANDE FOURNISSEUR' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">

                <!-- Date -->
                <div class="d-flex gap-120px">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Date</label></td>
                            <td><label class="size15-400">{{ documentDate !== '--' ? (documentDate | date:'dd/MM/yyyy') : '--' }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr>

                <!-- Statut -->
                <div class="d-flex gap-120px">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Statut</label></td>
                            <td><label class="size15-400">{{ documentStatut }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr>

                <!-- Entrepôt -->
                <div class="d-flex gap-100px" *ngIf="documentType === 'FACTURE' || documentType === 'BON DE LIVRAISON' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Entrepôt</label></td>
                            <td><label class="size15-400">{{ selectedItem?.warehouse || 'Entrepôt principal' }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType === 'BON DE LIVRAISON' || documentType === 'FACTURE' || documentType==='FACTURE FOURNISSEUR' || documentType==='BON RECEPTION'">

                <!-- Date de livraison -->
                <div class="d-flex gap-100px" *ngIf="documentType === 'COMMANDE CLIENT' || documentType === 'COMMANDE FOURNISSEUR'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Date de livraison</label></td>
                            <td><label class="size15-400">{{ deliveryDate !== '--' ? (deliveryDate | date:'dd/MM/yyyy') : '--' }}</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType === 'COMMANDE CLIENT' || documentType === 'COMMANDE FOURNISSEUR'">

                <!-- Projet -->
                <div class="d-flex gap-120px">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Projet</label></td>
                            <td><label class="size15-400">--</label></td>
                        </tr>
                    </table>
                </div>
                <hr>

                <!-- Catégories -->
                <div class="d-flex gap-120px" *ngIf="documentType==='FACTURE FOURNISSEUR'">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Catégories</label></td>
                            <td><label class="size15-400">--</label></td>
                        </tr>
                    </table>
                </div>
                <hr *ngIf="documentType==='FACTURE FOURNISSEUR'">

                <!-- Note -->
                <div class="d-flex gap-125px" *ngIf="showDescription && noteText">
                    <table>
                        <tr>
                            <td style="width: 174px"><label class="size15">Note</label></td>
                            <td><label class="size15-400">{{ noteText }}</label></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- Section Produits -->
        <div class="products-section">
            <table class="products-table table-bordered">
                <thead style="height: 56px; background-color: #134AD329">
                <tr>
                    <th>DÉSIGNATION</th>
                    <th>QUANTITÉ</th>
                    <th>QUANTITÉ DISPONIBLE</th>
                    <th>VALEUR UNITAIRE</th>
                    <th>TOTAL HT</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let product of products">
                    <td>{{ product.designation }}</td>
                    <td>{{ product.quantite }}</td>
                    <td>{{ product.disponible }}</td>
                    <td>{{ product.unite }}</td>
                    <td>{{ product.total }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- Section Totaux -->
        <div style="position: relative; width: 100%; max-width: 400px; margin-left: auto; margin-right: 50px;">
            <table class="table table-borderless text-start rounded totals-table">
                <tbody>
                <tr>
                    <td>Total HT</td>
                    <td>{{ totals.totalHT | number:'1.3-3' }} TND</td>
                </tr>
                <tr>
                    <td>Total TVA</td>
                    <td>{{ totals.totalTVA | number:'1.3-3' }} TND</td>
                </tr>
                <tr>
                    <td>Total TTC</td>
                    <td>{{ totals.totalTTC | number:'1.3-3' }} TND</td>
                </tr>
                <tr>
                    <td>Timbre fiscal</td>
                    <td>{{ totals.timbreFiscal | number:'1.3-3' }} TND</td>
                </tr>
                <tr class="fw-bold">
                    <td>Net à payer</td>
                    <td>{{ totals.netAPayer | number:'1.3-3' }} TND</td>
                </tr>
                </tbody>
            </table>
        </div>


        <!-- Footer Info -->
        <div class="footer-info d-flex justify-content-between">
            <div class="company-info">
                <p class="size15"><strong>Entreprise</strong></p>
                <p class="information">Shopi</p>
                <p class="information">l'aouina cité wahat, tunis</p>
                <p class="information">null tunis</p>
                <p class="information">Matricule fiscal: 5885</p>
            </div>
            <div class="coordinates">
                <p class="size15"><strong>Coordonnées</strong></p>
                <p class="information">--</p>
                <p class="information">--</p>
            </div>
            <div class="bank-info">
                <p class="size15"><strong>Coordonnées bancaires</strong></p>
                <p class="information">STB-Société Tunisienne de Banque</p>
                <p class="information">TN5910006035183509478831</p>
            </div>
        </div>
    </div>
</div>
